import { Guid } from "guid-typescript";

export interface ImportCSV {
	fileLookupId: Guid;
}

export class ImportCSV implements ImportCSV {	
	constructor(data?: Partial<ImportCSV>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}